<template>
  <div class="goodDetails">
    <div class="gotop" @click="toTop" v-if="show">
      <img src="../assets/image/home/top-icon.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.showBtn, true);
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showBtn() {
      // 获取滚动元素的滚动距离

      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      scrollTop > 1200 ? (this.show = true) : (this.show = false);
    },
    // 回到顶部
    toTop() {
      // 获取滚动元素的滚动距离
      console.log("top");
      document.documentElement.scrollTop = 0;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let scrollTop =
      //   document.getElementsByClassName("goodDetails")[0].scrollTop;
      // 定时器模拟动画慢速回到顶部
      let timer = setInterval(() => {
        // 每次上移的距离
        scrollTop -= 150;
        // scrollTop =
        //   window.pageYOffset ||
        //   document.documentElement.scrollTop ||
        //   document.body.scrollTop;
        // 如果到达顶部就清除定时器
        if (scrollTop <= 0) {
          clearInterval(timer);
        }
      }, 50);
    },
  },
};
</script>

<style lang="less" scoped>
.goodDetails {
  width: 100px;
  height: 100px;
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  position: relative;
  overflow-y: auto;
}
.gotop {
  width: 42px;
  height: 62px;
  position: fixed;
  bottom: 10%;
  // bottom: 120px;
  right: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  img {
    width: 100%;
  }
}
</style>